<template>
  <div>
    <custom-modal :title="'Opłata serwisowa'" :id="'penaltyForUserModal'">
      <template #content>
        <div class="modal-body">
          <p class="info-label mb-4">
            <span class="bold">
              Dodając opłatę serwisową wystawisz notę księgową.
            </span>
            <span>
              Jeżeli potrzebujesz ją skorygować skontaktuj się z lekarzem lub
              farmaceutą.
            </span>
          </p>

          <div v-if="stepNumber === 1">
            <p class="standard-label mb-0">Co zrobić?</p>
            <div class="question-radios">
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="newPenaltyDescription"
                  id="newPenaltyDescription"
                  v-model="newPenaltyDescription"
                  :value="true"
                />
                <label class="form-check-label" for="newPenaltyDescription">
                  Dodaj własny opis
                </label>
              </div>
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="newPenaltyDescription"
                  id="oldPenaltyDescription"
                  v-model="newPenaltyDescription"
                  :value="false"
                />
                <label class="form-check-label" for="oldPenaltyDescription"
                  >Wybierz istniejący opis</label
                >
              </div>
            </div>
            <div class="own-description" v-if="newPenaltyDescription">
              <p class="standard-label">Dodaj opis</p>
              <textarea
                name="own-description-penalty-textarea"
                id="own-description-penalty-textarea"
                maxlength="100"
                placeholder="Uzupełnij opis"
                v-model="selectedDescription"
              >
              </textarea>
              <div class="own-description-counter">
                {{ selectedDescription.length }} / 100
              </div>
            </div>
            <div class="own-description" v-else>
              <p class="standard-label">Dodaj opis</p>
              <div class="descriptions">
                <div
                  class="radio-box ml-2"
                  v-for="description in descriptions"
                  :key="description.id"
                >
                  <input
                    class="form-check-input"
                    type="radio"
                    name="selectedDescriptionPenalty"
                    :id="description.id"
                    :value="description.description"
                    v-model="selectedDescription"
                  />
                  <label class="form-check-label" :for="description.id">
                    <div class="description">
                      <div
                        class="description-name"
                        :class="
                          selectedDescription === description.description
                            ? 'font-weight-bold'
                            : ''
                        "
                      >
                        {{ description.name }}
                      </div>

                      <div class="ml-4 description-description">
                        "{{ description.description }}"
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>

            <p class="standard-label mt-4">Kwota</p>
            <input
              type="number"
              step="0.01"
              class="form-control"
              v-model="penaltyAmount"
              placeholder="Podaj kwotę"
            />

            <div class="buttons">
              <custom-button
                :gray="true"
                title="Anuluj"
                :size="'small'"
                @click="closeModal()"
                :customStyles="'text-transform: uppercase; width: 290px; height: 30px;'"
              />
              <custom-button
                :gradient="true"
                title="Dalej"
                :size="'small'"
                @click="moveToStepTwo"
                :customStyles="'text-transform: uppercase;width: 290px; height: 30px;'"
              />
            </div>
          </div>

          <div v-if="stepNumber === 2">
            <p class="standard-label mb-0">Co zrobić?</p>
            <div class="question-radios">
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="withOrder"
                  id="withOrder"
                  v-model="withOrder"
                  :value="true"
                />
                <label class="form-check-label" for="withOrder">
                  Wybierz zlecenie, którego dotyczy opłata
                </label>
              </div>
              <div class="radio-box">
                <input
                  class="form-check-input"
                  type="radio"
                  name="withOrder"
                  id="withoutOrder"
                  v-model="withOrder"
                  :value="false"
                />
                <label class="form-check-label" for="withoutOrder"
                  >Nie dodawaj informacji o zleceniu</label
                >
              </div>
            </div>

            <div v-if="withOrder">
              <p class="standard-label mt-4">ID zlecenia</p>
              <input
                type="text"
                class="form-control"
                v-model="selectedOrderId"
                placeholder="Wprowadź ID zlecenia, którego dotyczy opłata"
              />

              <div class="order-error" v-if="orderIdError">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="12"
                  viewBox="0 0 11 12"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11 5.79395C11 8.83151 8.53757 11.2939 5.5 11.2939C2.46243 11.2939 -1.29859e-07 8.83151 -2.90049e-07 5.79395C-4.50239e-07 2.75638 2.46243 0.293947 5.5 0.293946C8.53757 0.293946 11 2.75638 11 5.79395ZM4.92708 8.54395C4.92708 8.22753 5.18359 7.97103 5.5 7.97103C5.81641 7.97103 6.07292 8.22753 6.07292 8.54395C6.07292 8.86036 5.81641 9.11686 5.5 9.11686C5.18359 9.11686 4.92708 8.86036 4.92708 8.54395ZM5.5 7.16895C5.24687 7.16895 5.04167 6.96374 5.04167 6.71061L5.04167 3.04395C5.04167 2.79082 5.24687 2.58561 5.5 2.58561C5.75313 2.58561 5.95833 2.79082 5.95833 3.04395L5.95833 6.71061C5.95833 6.96374 5.75313 7.16895 5.5 7.16895Z"
                    fill="white"
                  />
                </svg>
                <span>{{ orderIdError }}</span>
              </div>
            </div>

            <div class="buttons">
              <custom-button
                :gray="true"
                title="Wstecz"
                :size="'small'"
                @click="moveToStepOne"
                :customStyles="'text-transform: uppercase; width: 290px; height: 30px;'"
              />
              <custom-button
                :gradient="true"
                title="Dalej"
                :size="'small'"
                @click="moveToStepThree"
                :customStyles="'text-transform: uppercase;width: 290px; height: 30px;'"
              />
            </div>
          </div>

          <div v-if="stepNumber === 3">
            <p class="standard-label mb-0">Wybierz dział w fakturownii</p>
            <div class="descriptions">
              <div
                class="radio-box ml-2"
                v-for="department in departments"
                :key="department.id"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  name="selectedDescriptionPenalty"
                  :id="`${department.id}_penalty`"
                  :value="department.id"
                  v-model="selectedDepartmentId"
                />
                <label
                  class="form-check-label"
                  :for="`${department.id}_penalty`"
                >
                  <div class="description">
                    <div
                      class="department-name"
                      :class="
                        selectedDepartmentId === department.id
                          ? 'font-weight-bold'
                          : ''
                      "
                    >
                      {{ department.name }}
                    </div>

                    <div class="ml-4 department-description">
                      "{{ selectedDescription }}"
                    </div>
                  </div>
                </label>
              </div>
            </div>
            <div class="buttons">
              <custom-button
                :gray="true"
                title="Wstecz"
                :size="'small'"
                @click="moveToStepTwo"
                :customStyles="'text-transform: uppercase; width: 290px; height: 30px;'"
              />
              <custom-button
                :disabled="loading"
                :gradient="true"
                title="Wystaw"
                :size="'small'"
                @click="handlePenalty()"
                :customStyles="'text-transform: uppercase;width: 290px; height: 30px;'"
              />
            </div>
          </div>
        </div>
        <large-amount-confirm
          :visible="largeAmountConfirmVisible"
          :amount="penaltyAmount"
          @confirmed="confirmLargeAmount"
          @cancel="largeAmountConfirmVisible = false"
        />
      </template>
    </custom-modal>
    <button
      style="visibility: hidden"
      id="penaltyForUserModal-open"
      type="button"
      data-toggle="modal"
      data-target="#penaltyForUserModal"
    />
  </div>
</template>

<script>
import axios from "../axios";
import CustomButton from "./CustomButton.vue";
import CustomModal from "./CustomModal.vue";
import LargeAmountConfirm from "./LargeAmountConfirm.vue";
import { requiresAmountConfirmation } from "../utils/largeAmount";
export default {
  components: { CustomModal, CustomButton, LargeAmountConfirm },
  emits: ["penalty-done"],
  name: "PenaltyPaymentModal",
  data() {
    return {
      penaltyAmount: null,
      loading: false,
      newPenaltyDescription: true,
      descriptions: [],
      departments: [],
      selectedDescription: "",
      selectedDepartmentId: null,
      stepNumber: 1,
      selectedOrderId: null,
      withOrder: false,
      orderIdError: "",
      largeAmountConfirmVisible: false,
    };
  },
  watch: {
    selectedOrderId() {
      this.orderIdError = "";
    },
  },
  async mounted() {
    const descriptionsResponse = await axios.get(
      `/api/accountingNoteDescriptions`
    );
    const departmentsResponse = await axios.get(
      `/api/payment/fakturowniaDepartments`
    );

    this.descriptions = descriptionsResponse.data;
    this.departments = departmentsResponse.data;
  },
  methods: {
    moveToStepOne() {
      this.stepNumber = 1;
    },
    moveToStepTwo() {
      if (!this.validateSelectedDescriptionAndAmount()) {
        return;
      }
      this.stepNumber = 2;
    },
    async moveToStepThree() {
      if (!(await this.validateSelectedOrderId())) {
        return;
      }
      this.stepNumber = 3;
    },
    closeModal() {
      this.newPenaltyDescription = true;
      this.selectedDescription = "";
      this.penaltyAmount = null;
      this.stepNumber = 1;
      this.selectedDepartmentId = null;
      this.selectedOrderId = null;
      this.orderIdError = "";
      this.largeAmountConfirmVisible = false;

      document.getElementById("penaltyForUserModal-close").click();
    },

    validateSelectedDescriptionAndAmount() {
      if (!this.selectedDescription) {
        this.$notify({
          group: "error",
          text: "Wymagane jest wybranie opisu z listy lub dodanie własnego",
        });
        return false;
      }
      if (!this.penaltyAmount) {
        this.$notify({
          group: "error",
          text: "Podaj kwotę opłaty serwisowej",
        });
        return false;
      }
      return true;
    },

    validateSelectedDepartment() {
      if (!this.selectedDepartmentId) {
        this.$notify({
          group: "error",
          text: "Wymagane jest wybranie działu w fakturownii",
        });
        return false;
      }
      return true;
    },

    async validateSelectedOrderId() {
      if (!this.withOrder) {
        return true;
      }
      if (!this.selectedOrderId) {
        const orderError = "Wprowadź ID zlecenia";
        this.orderIdError = orderError;
        this.$notify({
          group: "error",
          text: orderError,
        });
        return false;
      } else {
        try {
          await axios.get(`/api/order/checkUserBelongsToOrder`, {
            params: {
              orderId: this.selectedOrderId,
              userPhoneNumber: this.$route.query.search,
            },
          });
        } catch (error) {
          const orderError =
            "Dla tego użytkownika nie znaleziono zlecenia o podanym ID";
          this.orderIdError = orderError;
          this.$notify({
            group: "error",
            text: orderError,
          });
          return false;
        }
      }

      return true;
    },

    async handlePenalty() {
      if (!this.validateSelectedDescriptionAndAmount()) {
        return;
      }
      if (!this.validateSelectedDepartment()) {
        return;
      }
      // Keeps "Wystaw" disabled during the async order check, so a double click cannot submit twice.
      this.loading = true;
      const orderIdValid = await this.validateSelectedOrderId();
      this.loading = false;
      if (!orderIdValid) {
        return;
      }
      if (requiresAmountConfirmation(this.penaltyAmount)) {
        this.largeAmountConfirmVisible = true;
        return;
      }
      this.submitPenalty();
    },

    confirmLargeAmount() {
      this.largeAmountConfirmVisible = false;
      this.submitPenalty();
    },

    async submitPenalty() {
      try {
        this.loading = true;
        const url = `/api/payment/wallet/outcome`;
        const data = {
          amount: this.penaltyAmount,
          withoutAccountingNote: false,
          phoneNumber: this.$route.query.search,
          departmentId: this.selectedDepartmentId,
          noteDescription: this.selectedDescription,
          departmentName: this.departments.find(
            (department) => department.id === this.selectedDepartmentId
          ).name,
          orderId: this.selectedOrderId,
        };
        const response = await axios.post(url, data);
        if (response.status === 200) {
          this.$notify({
            group: "success",
            text: "Pomyślnie dodano opłatę serwisową dla użytkownika",
          });
          this.$emit("penalty-done");
          this.selectedDepartmentId = null;
          this.selectedDescription = "";
          this.penaltyAmount = null;
          this.stepNumber = 1;
          this.newPenaltyDescription = true;
          this.withOrder = true;
          this.selectedOrderId = null;
          this.orderIdError = "";

          this.closeModal();

          setTimeout(() => {
            this.loading = false;
          }, 2000);
        }
      } catch (error) {
        console.log(error);
        setTimeout(() => {
          this.loading = false;
        }, 2000);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.modal-body {
  font-size: 14px;
  padding: 10px;
}
div {
  padding: 0;
}
.info-label {
  font-size: 18px;
  font-style: normal;
  line-height: 30px;
}
.bold {
  font-weight: 600;
}
.standard-label {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  margin-top: 30px;
}
.question-radios {
  display: flex;
  gap: 4rem;
  margin-left: 1.25rem;
}
.descriptions {
  margin-left: 1rem;
}
.radio-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 10px;
}
.form-check-label {
  margin-left: 5px;
  margin-top: 5px;
  cursor: pointer;
}
input[type="radio"] {
  accent-color: #e2037e;
}
.own-description {
  margin-top: 1rem;
}
.own-description textarea {
  width: 100%;
  padding: 10px;
  font-size: 14px;
}
input {
  font-size: 14px;
}
.description {
  display: flex;
  align-items: center;
}
.description-name {
  width: 255px;
  max-width: 255px;
  min-width: 255px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.description-description {
  width: 80%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 3rem;
}

.department-name {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.department-description {
  width: 65%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.order-error {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 13.479px;
  color: white;
  padding: 5px;
  border-radius: 4.289px;
  background: #ff1a1a;
}
.own-description-counter {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 13.479px;
  color: var(--granatowy-25, rgba(9, 7, 65, 0.25));
  text-align: right;
}
</style>